

const index = ({ value, inputLabel, type = "normal" }) => {

    return (
        <div className={`static-text-field form-group ${value ? 'focused' : ''}`}>
            <label className="form-label">
                {inputLabel}
            </label>
            <span className={'d-flex input_vw'} style={ value ? {} : { color: 'transparent' } }>
                {
                    value ? value : '-'
                }
            </span>
            {
                type === "date" && (
                    <div className="calendar_icon"></div>
                )
            }
        </div>
    )
}

export default index